<template>
    <page
        showStepBackButton
        @step-back="stepBack"
        ref="page"
        :stepCount="stepCount"
        :step="formData.formstep"
        showMiniStepper
    >
        <transition name="fade" mode="out-in">
            <welcome
                :mode="formData.mode"
                :welcomeText="welcomeText"
                v-if="showWelcomeSection"
                @hide="showWelcomeSection = false"
            ></welcome>
            <stepper
                v-model="formData.formstep"
                hideProgress
                :count="stepCount"
                v-else
            >
                <stepper-item :step="stepMap.schadenArt">
                    <ereignis
                        :mode="formData.mode"
                        @change="changeFormData"
                        title="Was war der Grund für den Krankenhausaufenthalt?"
                    />
                </stepper-item>
                <stepper-item :step="stepMap.vonBis">
                    <von-bis
                        @change="changeFormData"
                        title="Wie lange dauerte der Aufenthalt?"
                    />
                </stepper-item>
                <stepper-item :step="stepMap.krankenhaus">
                    <wert
                        title="In welchem Krankenhaus war der Aufenthalt?"
                        label="Name des Krankenhauses"
                        id="krankenhaus"
                        @change="changeFormData"
                    />
                </stepper-item>
                <stepper-item :step="stepMap.aufenthaltsbestaetigung">
                    <h2>Bitte lade die Aufenthaltsbestätigung hoch</h2>
                    <files-upload
                        v-model="formData.aufenthaltsbestaetigung"
                        :multiple="true"
                        id="aufenthaltsbestaetigung"
                        flexDirection="row-reverse"
                    ></files-upload>
                    <div class="ion-text-right">
                        <ion-button
                            class="-round -add-padding ion-margin-top"
                            :disabled="
                                formData.aufenthaltsbestaetigung.length === 0
                            "
                            @click="changeFormData([])"
                            >Weiter</ion-button
                        >
                    </div>
                </stepper-item>
                <stepper-item :step="stepMap.vertrag">
                    <vertrag-auswahl
                        :feature="feature"
                        @change="changeFormData"
                        v-if="
                            $store.state.isLoggedIn &&
                            hasSchadensmeldungContract
                        "
                        :isVisible="formData.formstep === stepMap.vertrag"
                    />
                    <!-- TODO: Welche Polizzen gehören hier hinein? -->
                    <wert
                        title="Bitte gib hier deine Wüstenrot PrimaMed?-Versicherungspolizze an"
                        label="Polizzennummer"
                        id="polizzenversicherung"
                        type="text"
                        @change="changeFormData"
                        v-else
                    />
                </stepper-item>
                <stepper-item :step="stepMap.person">
                    <person
                        @change="changeFormData"
                        :mode="formData.mode"
                        :contractId="formData.polizzenversicherung"
                    />
                </stepper-item>
                <stepper-item :step="stepMap.zusammenfassung">
                    <zusammenfassung
                        :formData="formData"
                        @change-step="changeStep"
                        :stepMap="stepMap"
                    />
                    <div class="ion-text-center ion-margin-bottom">
                        <ion-button
                            class="-round -add-padding"
                            @click="submitForm"
                            >Schaden melden</ion-button
                        >
                    </div>
                </stepper-item>
            </stepper>
        </transition>
    </page>
</template>

<script>
import Page from "@/components/Page";
import Welcome from "@/components/schadensmeldung/Welcome";
import Stepper from "@/components/Stepper";
import StepperItem from "@/components/StepperItem";
import Ereignis from "@/components/schadensmeldung/Ereignis";
import VonBis from "@/components/schadensmeldung/VonBis";
import Wert from "@/components/schadensmeldung/Wert";
import FilesUpload from "@/components/FilesUpload";
import VertragAuswahl from "@/components/schadensmeldung/VertragAuswahl";
import Person from "@/components/schadensmeldung/Person";
import Zusammenfassung from "@/components/schadensmeldung/Zusammenfassung";
import { schadensmeldungNeu } from "@/mixins/schadensmeldungNeu";

export default {
    mixins: [schadensmeldungNeu],
    components: {
        Page,
        Welcome,
        Stepper,
        StepperItem,
        Ereignis,
        VonBis,
        Wert,
        FilesUpload,
        VertragAuswahl,
        Person,
        Zusammenfassung,
    },
    data() {
        return {
            feature: "SchadensmeldungKrankenhaus",
            formData: {
                mode: "krankenhaus",
                formstep: 1,
                schadenArt: "",
                von: "",
                bis: "",
                krankenhaus: "",
                aufenthaltsbestaetigung: [],
                polizzenversicherung: "",
                geschlecht: "",
                vorname: "",
                zuname: "",
                geburtsdatum: "",
                email: "",
                telefon: "",
                iban: "",
                // schadensfotos auf null, damit in zusammefassung ausgeblendet
                schadensfotos: null,
            },
        };
    },
    computed: {
        stepCount() {
            return 7;
        },
        stepMap() {
            return {
                schadenArt: 1,
                vonBis: 2,
                krankenhaus: 3,
                aufenthaltsbestaetigung: 4,
                vertrag: 5,
                person: 6,
                zusammenfassung: 7,
            };
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped></style>
